import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 当前处于激活状态的nav索引
        navLv1: '1',
        navLv2: '1',
        navLv3: '1',
        ServiceGroup:[], // 客服组
        userMsg:{},      // 当前登陆者的信息
        customerMsg:{},  // 当前正在聊天的顾客信息
        chatingList:[],  // 正在聊天的访客列表
        pushGoodMsg:{},  // 推送临时商品信息
        pushShopGoodMsg:{},  // 推送商城商品信息
        connectState:0,  // socket连接状态 0 未连接 1 需要连接 2连接成功 5连接失败
        repairFeeMsg:{}, // 客服发送上门和救援维修费用信息
    },
    getters:{
        getPushGoodMsg: state => {
            return state.pushGoodMsg;
        },
        getPushShopGoodMsg: state => {
            return state.pushShopGoodMsg;
        },
        getNavLv2: state => {
            return state.navLv2;
        },
        getConnectState: state => {
            return state.connectState;
        },
        getCurrChatClient:state=> {
            return state.customerMsg;
        },
        getRepairFeeMsg:state=>{
            return state.repairFeeMsg;
        }
    },
    mutations: {
        // 客服发送上门和救援维修费用信息
        updateRepairFeeMsg(state,params){
            state.repairFeeMsg = params;
        },
        // 当前正在聊天的顾客信息
        updateCustomerMsg(state,params){
            state.customerMsg = params;
        },
        // 更新导航active状态
        updateNav(state,params){
            state.navLv1 = String(params.n1);
            state.navLv2 = String(params.n2);
            state.navLv3 = String(params.n3);
        },
        // 客服组
        updateServiceGroup(state,params){
            state.ServiceGroup = params;
        },
        // 当前登陆者的信息
        updateUserMsg(state,params){
            state.userMsg = params;
        },
        // 正在聊天的访客列表
        updateChatingList(state,params){
            state.chatingList = params;
        },
        // 推送临时商品信息
        updatePushGoodMsg(state,params){
            state.pushGoodMsg = params;
        },
        // 推送商城商品信息
        updatePushShopGoodMsg(state,params){
            state.pushShopGoodMsg = params;
        },
        // socket连接状态
        updateConnectState(state,params){
            state.connectState = params;
        }
    },
    actions: {

    }
})
